import { render, staticRenderFns } from "./taskRelationshipVip.vue?vue&type=template&id=12ade9bc&"
import script from "./taskRelationshipVip.vue?vue&type=script&lang=js&"
export * from "./taskRelationshipVip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports